import {
  AlarmClockIcon,
  ArrowsMultipleUpIcon,
  FlameIcon,
  GraduatedPairIcon,
  TokenAgeIcon,
} from '@root/shared/ui-kit'

import type { IconProps } from '@blade/ui-kit'
import type { TransKey } from '@root/shared/localization'

export const ExploreFeedType = {
  Trending: 'Trending::ExploreFeedType',
  New: 'New::ExploreFeedType',
  Cooking: 'Cooking::ExploreFeedType',
  TopGainers: 'TopGainers::ExploreFeedType',
  Graduated: 'Graduated::ExploreFeedType',
  /**
   * Pools still on a curve, closest to graduating first.
   *
   * Not the same list as Cooking, which is about the last five minutes of
   * trading and says nothing about a curve.
   */
  FinalStretch: 'FinalStretch::ExploreFeedType',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ExploreFeedType =
  (typeof ExploreFeedType)[keyof typeof ExploreFeedType]

export const EXPLORE_SCREEN_TABS: Array<ExploreFeedType> = [
  ExploreFeedType.New,
  ExploreFeedType.Trending,
  ExploreFeedType.Cooking,
  ExploreFeedType.TopGainers,
  ExploreFeedType.Graduated,
]

export const ExploreTypeMap: Record<
  ExploreFeedType,
  { Icon: React.FC<IconProps>; label: TransKey; color: string }
> = {
  [ExploreFeedType.Trending]: {
    Icon: FlameIcon,
    label: 'explore.trending-tokens',
    color: 'var(--red-9)',
  },
  [ExploreFeedType.New]: {
    Icon: TokenAgeIcon,
    label: 'new-pairs',
    color: 'var(--green-9)',
  },
  [ExploreFeedType.Cooking]: {
    Icon: AlarmClockIcon,
    label: 'explore.cooking',
    color: 'var(--blue-9)',
  },
  [ExploreFeedType.TopGainers]: {
    Icon: ArrowsMultipleUpIcon,
    label: 'explore.trending-gainers',
    color: 'var(--blue-7)',
  },
  [ExploreFeedType.Graduated]: {
    Icon: GraduatedPairIcon,
    label: 'explore.graduated',
    color: 'var(--amber-9)',
  },
  [ExploreFeedType.FinalStretch]: {
    Icon: FlameIcon,
    label: 'explore.cooking',
    color: 'var(--blue-9)',
  },
}
